import React from 'react';
import { Link } from '@mui/material';
import { Box } from '@mui/system';

import {
  CARD_LINK_SX, CardExcerpt, CardSubheader, CardTitle, IdentityStack, MediaWrap,
} from './styles';
import useFactsFit, { FACTS_CLASS, factClass } from './useFactsFit';
import { useCardShows } from './useCardDensity';

/**
 * Everything on an entity card above the footer: its picture, name, facts line
 * and blurb, as one click target that opens the entity. `facts` comes from
 * `entityFacts`, in display order; a crowded line sheds from the tail of
 * `SHED_ORDER` rather than wrapping. `overlay` is pinned over the media frame —
 * the heat/buzz badge, which positions itself in the frame's corner.
 */
export default function CardIdentity({
  media, overlay, title, facts, excerpt, onOpen,
}) {
  const { stackRef, shed } = useFactsFit(facts.map((fact) => fact.text).join('|'));
  const shows = useCardShows();

  return (
    <Link color="inherit" underline="none" onClick={onOpen} sx={CARD_LINK_SX}>
      <MediaWrap>
        {media}
        {overlay}
      </MediaWrap>
      <IdentityStack ref={stackRef} data-shed={shed}>
        <CardTitle variant="h5">{title}</CardTitle>
        {shows('facts') && facts.length > 0 && (
          <CardSubheader className={FACTS_CLASS} variant="caption">
            {facts.map((fact, index) => (
              <Box component="span" key={fact.key} className={factClass(fact.key)}>
                {index === 0 ? fact.text : ` · ${fact.text}`}
              </Box>
            ))}
          </CardSubheader>
        )}
        {excerpt && <CardExcerpt variant="subtitle2">{excerpt}</CardExcerpt>}
      </IdentityStack>
    </Link>
  );
}
